import React from "react";
import { useTranslation } from "react-i18next";

// common
import {
  ModalText,
  ModalLayout,
  LargeModalStyling,
  MoreModalButtons,
} from "common/modal";

// modals
const { LargeModal } = LargeModalStyling;
const { ConfirmationText } = ModalText;
const { ModalRow } = ModalLayout;
const { ModalButtonYellow, ButtonContainer } = MoreModalButtons;

type GroupModalProps = {
  visible: boolean;
  onCloseModal: () => void;
};

const PastClassModal = ({ visible, onCloseModal }: GroupModalProps) => {
  const { t } = useTranslation("book_a_class");

  return (
    <LargeModal
      title={t("MY GROUP CLASS")}
      centered
      visible={visible}
      footer={null}
      onCancel={onCloseModal}
    >
      <ConfirmationText>
        {t(
          "This class is already finished. You cannot book it anymore. You can still join other future classes in this course."
        )}
      </ConfirmationText>
      <ModalRow gutter={24}>
        <ButtonContainer xs={20} sm={20} md={12}>
          <ModalButtonYellow
            type="primary"
            onClick={() => {
              onCloseModal();
            }}
          >
            {t("OKAY")}
          </ModalButtonYellow>
        </ButtonContainer>
      </ModalRow>
    </LargeModal>
  );
};

export default PastClassModal;
